import { forwardRef } from 'react'
import { Icon } from 'semantic-ui-react'

import { cn } from '@repo/utils'

import type { ComponentProps, HTMLAttributes } from 'react'

interface InfoProps extends HTMLAttributes<HTMLDivElement> {
  accent?: 'blue' | 'default' | 'green' | 'orange' | 'red' | 'teal'
  basic?: boolean
  classNameContent?: string
  icon?: ComponentProps<typeof Icon>['name']
  iconLoading?: boolean
}

const Info = forwardRef<HTMLDivElement, InfoProps>(
  (
    { accent = 'default', basic = false, children, className, classNameContent, icon, iconLoading = false, ...props },
    ref,
  ) => (
    <div
      className={cn(
        'Info flex items-center gap-1.5 py-2 px-3 border rounded-md overflow-hidden',
        accent === 'blue' && 'bg-blueLightest border-blueLight',
        accent === 'default' && 'bg-greyLightest border-greyDarkBlue',
        accent === 'green' && 'bg-greenLightest border-greenLight',
        accent === 'orange' && 'bg-orangeLightest border-orangeLight',
        accent === 'red' && 'bg-redLightest border-redLight',
        accent === 'teal' && 'bg-transparent border-tealLight',
        basic ? '!bg-transparent' : 'shadow shadow-greyLightMed',
        className,
      )}
      {...props}
      ref={ref}
    >
      {icon && (
        <Icon
          className={cn(
            '!m-0 !leading-inherit self-start',
            accent === 'blue' && 'text-blue',
            accent === 'default' && 'text-greyDarkBlue',
            accent === 'green' && 'text-green',
            accent === 'orange' && 'text-orange',
            accent === 'red' && 'text-red',
            accent === 'teal' && 'text-teal',
          )}
          loading={iconLoading}
          name={icon}
        />
      )}
      <div className={cn('grow', classNameContent)}>{children}</div>
    </div>
  ),
)

Info.displayName = 'Info'

export default Info
